import React from "react";

/** Phase AA4-FIX — prevent Acharya UI blank screen on render errors. */
export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, info) {
    console.error("[Acharya ErrorBoundary]", error, info);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div
          className="rounded-lg border border-border/60 bg-muted/30 p-6 text-center text-sm text-muted-foreground"
          data-testid="acharya-error-boundary"
        >
          Something went wrong. Please try again.
        </div>
      );
    }
    return this.props.children;
  }
}
